import { useState, useCallback } from "react";

import debounce from "lodash/debounce";

const TIMEOUT_CONFIG = 500;

const useSearchAutoComplete = <T>(
  defaultValue?: T | null | undefined,
  resetPage?: () => void
) => {
  const [keyword, setKeyword] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  const [forceRetry, setForceRetry] = useState<Date | null>();
  const [value, setValue] = useState<
    { label: string; value: T | null | undefined } | null | undefined
  >(
    defaultValue
      ? {
          label: String(defaultValue) || "",
          value: defaultValue,
        }
      : undefined
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSetKeyword = useCallback(
    debounce((txt: string, reason: string) => {
      if (reason === "input") {
        setKeyword(txt);
        if (resetPage) resetPage();
      }
      if (reason === "clear") {
        setKeyword(txt);
      }
    }, TIMEOUT_CONFIG),
    []
  );

  const onChange = (
    newValue: { label: string; value: T | null | undefined } | null
  ) => {
    setValue(newValue);
  };

  const onFocus = () => {
    if (!keyword) {
      setForceRetry(new Date());
    }
    if (!isFocus) setIsFocus(true);
  };
  const onBlur = () => setIsFocus(false);

  return {
    keyword,
    value,
    isFocus,
    forceRetry,
    setIsFocus,
    onChange,
    setKeyword: debounceSetKeyword,
    onFocus,
    onBlur,
  };
};

export default useSearchAutoComplete;
